import Question from "../stress_question/questions";
import StressLevel from "../stress_question/stress_level";
import { sale_email } from "./share";
export default {
	translation: {
		questions: Question.en,
		stress_level: StressLevel.en,
		sale_email,
		nothing_here: "Nothing here.",
		loginPage: {
			welcome: "Welcome to Ooca Corporate",
			titleLogin: "Please login with your corporate email.",
			titleForgotPassword:
				"Please enter your email address for recover your account.",
			checkUsername:
				"The username must be either an email or a mobile phone number.",
			requireUsername: "Please input your username!",
			requirePassword: "Please input your password!",
			linkForgotPassword: "Forgot Password ?",
			linkBackToLogin: "Back To Login",
			btnForgotPassword: "Forgot Password ?",
			btnLogin: "Login"
			//btnForgotPassword: "Forgot Password"
		},
		edit: "Edit",
		delete: "Delete",
		create_new_attribute: "Create new Attribute",

		pin: "PIN",
		user: "User",
		total_user: "Total Users",
		test_session: "Test session",
		total_test_session: "Total Test session",
		counseling_session: "Counseling session",
		female: "Female",
		male: "Male",
		department: "Department",
		age_range: "Age range",
		send: "Send",
		package_format: "Package %{name}",
		buy_package: "Buy package",
		contact_buy_package: "Please contact sales at",
		expired: "Expired",
		expiration_date: "Expiration date",
		expire_date: "Expire in %{expireIn} days",

		pick_export_date: "Select export date",
		export_excel: "Export Excel",
		export_filter_require: "Pick some graph data to use as export filter",
		primary: "Primary",
		secondary: "Secondary",
		custom: "Custom",
		no_data: "No data here",
		all: "All",

		tag: "Tag",
		provider: "Provider",
		provider_type: "Provider Type",
		duration: "Duration",
		unknown_date: "...",
		unknown_duration: "...",
		platform: "Platform",
		topic: "Topic",
		user_retention: "User Retention",
		visit_feedback: "Visit Feedback",
		visit_frequency: "Visit Frequency",
		patient_feedback: "Patient Feedback",
		provider_feedback: "Provider Feedback",
		visit_outcome: "Visit Outcome",

		session: "Session",
		counseling: "Counseling",
		counseling_session: "Counseling session",
		counseling_visit: "Counseling visit",
		counseling_overview: "Overview",

		stress_test: "Stress test",
		stress_level: "Stress Level",
		stress_level_label: "Stress Level",
		stress_level_overview: "Stress level overview",
		stress_level_target: "Stress Level (User)",
		stress_level_format: "Level %{level} %{detail}",
		level_format: "Level %{level}",
		returning_time_format: "%{time} Times",
		returning_more_time_format: "%{time} Times and more",
		stress_age_range_label: "Age range (year)",
		returning_user: "Returning Users",
		account_information: "Account Information",
		username: "Username",
		password: "Password",
		requireCurrentPassword: "Please input your current password!",
		requireNewPassword: "Please input your new password!",
		requireConfirmPassword: "Please confirm your password!",
		currentPassword: "Your current Password",
		newPassword: "New Password",
		confirmPassword: "Confirm New Password",
		unassign: "Unassign",
		good: "Good",
		bad: "Bad",
		next_week: "Next week",
		two_weeks: "Two Week",
		next_month: "Next Month",
		hospital: "Hospital",
		psychiatrist: "Psychiatrist",

		people: "People",
		people_overview: "Overview",
		people_individual_user: "Individual user",
		popular_topic: "Popular Topics",

		search: "Search",
		search_placeholder: {
			email: "Search E-mail"
		},
		gender: "Gender",
		collapse: "Collapse",
		clear: "Clear",
		save: "Save",
		cancel: "Cancel",
		preview: "Preview",
		yes: "Yes",
		no: "No",
		loading: "Loading",
		loadings: {
			apply_change: "Apply change..."
		},
		load_more: "Load more...",
		submit: "Submit",
		thumb_up: "Thumb up",
		thumb_down: "Thumb down",

		siderTap: {
			home: "Home",
			report: "Report",
			counseling: "Counseling",
			people: "People",
			test: "Test",
			stress_test: "Stress Test",
			usage_overview: "Usage Overview",
			people_overview: "Overview",
			individual_user: "Individual User",
			counseling_overview: "Overview",
			view_coun_by_provider: "View by Provider",
			view_coun_by_platform: "View by Platform",
			view_coun_by_topic: "View by Topic",
			view_coun_by_age_range: "View by Age range",
			view_coun_by_gender: "View by Gender",
			view_coun_by_user_retention: "View by User Retention",
			view_coun_by_visit_feedback: "View by Visit Feedback",
			view_coun_by_visit_outcome: "View by Visit Outcome",
			individual_question: "Individual Question",
			view_stress_by_level: "View by Stress Level",
			view_stress_by_age: "View by Age range",
			view_stress_by_gender: "View by Gender",
			view_stress_by_department: "View by Department",
			view_stress_by_returning: "View by Returning",
			view_by: "View by %s",
			account: "Account Management",
			setting: "Setting"
		},
		session_by: {
			topic: "Session by Topic",
			gender: "Session by Gender",
			age_range: "Session by Age Range",
			provider: "Session by Provider",
			feedback: "Visit Feedback",
			platform: "Session by Platform",
			returning: "User Retention",
			visit_outcome: "Visit Outcome"
		},
		visit_by: {
			topic: "Visit by Topic",
			gender: "Visit by Gender",
			age_range: "Visit by Age Range",
			provider: "Visit by Provider",
			feedback: "Visit Feedback",
			platform: "Visit by Platform",
			returning: "User Retention",
			visit_outcome: "Visit Outcome"
		},
		appearance: "Appearance",
		cooperate_name: {
			label: "Cooperate Name",
			placeholder: "cooperate name",
			require_warning: "Please input your cooperate name"
		},
		cooperate_color: {
			label: "Cooperate Color",
			require_warning: "Color cannot be empty"
		},
		color: {
			placeholder_code: "FFFFFF"
		},

		cooperate_updated: {
			title: "Cooperate update",
			success: "Cooperate data has been updated",
			error: "Fail to update cooperate data"
		},
		logo_upload: {
			upload_message: "Upload Image",
			remove_message: "Remove Image",
			remove_logo: {
				title: "Remove logo",
				message: "Are you sure to remove logo?"
			},
			// \n to seperate each wording. (because array value is not working!)
			guideline_message: [
				"Upload guideline: ",
				"White cooprate logo",
				"PNG file only | File size not over 150x150 px"
			].join("\n"),
			upload_fail: {
				title: "Upload logo fail",
				message: "Something went wrong, please try again later."
			}
		},
		activity_log: {
			header: "Activity Logs",
			titles: {
				activity: "Activity",
				date: "Date",
				by: "By"
			}
		},
		session_activity_log: {
			header: "Activity Logs",
			titles: {
				recent_activity: "Recent Activity",
				status: "Status",
				duration: "Duration",
				created: "Created",
				start: "Start"
			}
		},
		remaining_sessions: "Remaining Sessions",
		used_sessions: "Used Sessions",
		used_visits: "All Visits",
		all_session: "All Session",
		all_visits: "All Visits",
		all_time: "All time",
		hotline: "Hotline",
		in_app: "In App",
		visit: "Visit",
		visited: "Visited",
		session_filter: {
			all: "All Visits",
			completed: "Completed",
			ongoing: "Ongoing",
			pending: "Pending",
			incomplete: "Incomplete",
			cancelled: "Cancelled"
		},
		sessions: {
			all: "All Visits",
			completed: "Completed Visits",
			ongoing: "Ongoing Visits",
			pending: "Pending Visits",
			incomplete: "Incomplete Visits",
			cancelled: "Cancelled Visits"
		},
		admin_setting: "Admin setting",
		set_admin: "Set Admin",
		remove_admin: "Remove Admin",
		add_admin_success: "Admins has been added",
		delete_admin_success: "Admins has been removed",
		admin_limit_warning: "*Only %s admins can be added",
		call_channel: "Call channel",
		call_channels: {
			unknown: "Unknown",
			video_call: "Video call",
			web: "Video call",
			hotLine: "Hot-line",
			phone: "Hot-line"
		},

		time: {
			label: "Time",
			hour: {
				short: "hr",
				long: "hours"
			},
			minute: {
				short: "min",
				long: "minute"
			},
			second: {
				short: "sec",
				long: "second"
			}
		},

		send_test_invitation_email: "Send Test invite Email",

		send_email_select: "Send select",
		send_email_all: "Send to all",
		send_email_registered: "Send to all registered users",
		send_email_not_registered: "Send to all not registered users",
		send_email_all_ask: "Are you sure to send email to all user?",

		send_invitation_email: "Send Invitation Email",
		send_invitation_email_success: "Invitation has been sended",
		send_email_language_ask_title: "Email language",
		send_email_language_ask_message:
			"Which langauge do you want to send email as?",
		send_email_require: "Email require",
		select_some_email_warning: "You need to select some email to send to.",

		// ========== Report ==========
		vs: "vs.",
		select_interval: "Select Interval",
		question_path_syntax: "Question %{index}",
		question_label_syntax: "Question %{index} (%{user})",
		choice_path_syntax: "Choice %{index}",
		noone_chooses_choice: "No one choose this choice",

		account_analytic_headcount: "Analytic Headcount",
		account_registered_user: "Registered User",

		not_enough_data_title: "Not enough data",
		// ============================
		default_error: {
			title: "Unexpected error has occurred",
			message: "Please try again later"
		},
		service_unavailable: {
			title: "Service unavailable",
			message: "Service unavailable for now, please try again later"
		},
		server_error: {
			title: "Something went wrong",
			message:
				"Please check your connection or contact support@ooca.co for help."
		},
		develop_area: "Development area"
	}
};



// WEBPACK FOOTER //
// ./src/i18n/locales/en.js